import gql from 'graphql-tag';
import {
  FavoriteStateLightMode,
  FavoriteStateStatus,
} from '@/queries/fields/favoriteStateFields';

export namespace WizclickFields {
  export const fragment = gql`
    fragment wizclickSettingsFields on WizclickSettings {
      ... on FavoriteStateStatus {
        status
      }
      ... on FavoriteStateScene {
        sceneId
        specificDimming
        speed
      }
      ... on FavoriteStateCustomWhite {
        temperature
        dimming
      }
      ... on FavoriteStateCustomColor {
        r
        g
        b
        cw
        ww
        dimming
      }
    }
  `;

  export type Definition = FavoriteStateStatus | FavoriteStateLightMode;
}
